import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import {
  productListReducer,
  productDetailsReducer,
  productDeleteReducer,
  productCreateReducer,
  productUpdateReducer,
  productReviewCreateReducer,
  productTopRatedReducer,
  productStatsReducer,
  productSearchReducer,
  productReviewAddReducer,
  productReviewsReducer,
  deleteProductReviewsReducer,
  productListPromotionReducer,
} from './reducers/productReducers'
import { cartReducer } from './reducers/cartReducers'
import {
  userLoginReducer,
  userRegisterReducer,
  userDetailsReducer,
  userUpdateProfileReducer,
  userListReducer,
  userDeleteReducer,
  userUpdateReducer,
  userSubscribeReducer,
  userSubscriberListReducer,
} from './reducers/userReducers'
import {
  orderCreateReducer,
  orderDetailsReducer,
  orderPayReducer,
  orderDeliverReducer,
  orderListMyReducer,
  orderListReducer,
  orderStatsReducer,
  pickupListReducer,
  deletePickupReducer,
  addPickupReducer,
} from './reducers/orderReducers'
import { sliderListReducer } from './reducers/sliderReducer'
import { categoryCreateReducer, categoryListReducer } from './reducers/categoryReducers'
import { couponReducer } from './reducers/couponReducers'

const reducer = combineReducers({
  productList: productListReducer,
  productListPromotion: productListPromotionReducer,
  productSearch: productSearchReducer,
  productStats: productStatsReducer,
  productDetails: productDetailsReducer,
  sliderList: sliderListReducer,
  productDelete: productDeleteReducer,
  productCreate: productCreateReducer,
  productUpdate: productUpdateReducer,
  productReviewCreate: productReviewCreateReducer,
  productTopRated: productTopRatedReducer,

  categoryList: categoryListReducer,
  categoryCreate: categoryCreateReducer,


  orderStats: orderStatsReducer,

  cart: cartReducer,

  coupon: couponReducer,

  userLogin: userLoginReducer,
  userRegister: userRegisterReducer,
  userDetails: userDetailsReducer,
  userUpdateProfile: userUpdateProfileReducer,
  userList: userListReducer,
  userDelete: userDeleteReducer,
  userUpdate: userUpdateReducer,
  userSubscribe: userSubscribeReducer,

  listSubscribers: userSubscriberListReducer,

  orderCreate: orderCreateReducer,
  orderDetails: orderDetailsReducer,
  orderPay: orderPayReducer,
  orderDeliver: orderDeliverReducer,
  orderListMy: orderListMyReducer,
  orderList: orderListReducer,
  pickupList: pickupListReducer,
  deletePickup: deletePickupReducer,
  addPickup: addPickupReducer,
  addProductReview: productReviewAddReducer,
  productReviews: productReviewsReducer,
  deleteProductReviews: deleteProductReviewsReducer
})

const cartItemsFromStorage = localStorage.getItem('cartItems1')
  ? JSON.parse(localStorage.getItem('cartItems1'))
  : []

const userInfoFromStorage = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo'))
  : null

const shippingAddressFromStorage = localStorage.getItem('shippingAddress')
  ? JSON.parse(localStorage.getItem('shippingAddress'))
  : {}

const initialState = {
  cart: {
    cartItems: cartItemsFromStorage,
    shippingAddress: shippingAddressFromStorage,
  },
  userLogin: { userInfo: userInfoFromStorage },
}

const middleware = [thunk]

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
)

export default store
